import { Component, OnInit } from '@angular/core';
import { AuthService } from './../auth.service';

@Component({
  selector: 'app-signin-oidc',
  templateUrl: './signin-oidc.component.html',
  styleUrls: ['./signin-oidc.component.css']
})
/** signin-oidc component*/
export class SigninOidcComponent implements OnInit {
  /** signin-oidc ctor */
  constructor(private authService: AuthService) {
    let account = this.authService.getAccountDetails();
    console.log(account);
  }

  ngOnInit() {
    this.authService.initializeAuth();
  }
}
